<template>
  <div>
    <data-table-card
      :items="items"
      v-on:updateData="getEngagements"
      :sortOptions="sortOptions"
      :filterOptions="filterOptions"
      :sort="sort"
      :isLoad="isLoad"
      :page="page"
      :rowsPerPage="rowsPerPage"
      :fromRow="fromRow"
      :toRow="toRow"
      :totalRows="totalRows"
      :lastPage="lastPage"
    >
      <template
        v-slot:header-buttons
        v-if="userHasPerms(['Manage engagements'])"
      >
        <b-button
          class="ml-2"
          :to="{ name: 'engagements-create' }"
          variant="primary"
        >
          <i class="lni lni-circle-plus m-0"></i>
        </b-button>
      </template>

      <template v-slot:cards="slotProps">
        <router-link
          :to="{
            name: 'engagements-show',
            params: { id: slotProps.item.id },
          }"
          class="text-body pointer text-decoration-none"
        >
          <div class="row no-gutters">
            <div class="col-4 col-xl-3 p-1">
              <v-lazy-image
                v-if="slotProps.item.stakeholder.image"
                :src="slotProps.item.stakeholder.image"
                class="img-fluid"
              />

              <div
                class="mt-1 py-1 font-weight-bold text-center font-size-11 text-white"
                :class="{
                  'bg-success': slotProps.item.status == 'Engaged',
                  'bg-danger': slotProps.item.status == 'Cancelled',
                  'bg-warning': slotProps.item.status == 'Created',
                }"
              >
                {{ slotProps.item.status }}
              </div>
            </div>
            <div class="col-8 col-xl-7 p-3">
              <h5 class="font-weight-bold">
                {{ slotProps.item.stakeholder.name }}
              </h5>
              <strong class="text-primary">
                {{
                  moment(new Date(slotProps.item.engagement_date)).format(
                    "DD MMM YY, HH:mm"
                  )
                }}
              </strong>
              | {{ slotProps.item.mode }}
              <br />

              <small
                class="text-small text-black-50 nl2br"
                v-if="slotProps.item.status == 'Created'"
                >{{ slotProps.item.stakeholder.physical_address }}</small
              >

              <h5
                class="font-weight-bold text-warning"
                v-if="
                  slotProps.item.status == 'Engaged' &&
                  slotProps.item.check_out_at == null
                "
              >
                Checked In
              </h5>

              <h5
                class="font-weight-bold text-success"
                v-if="
                  slotProps.item.status == 'Engaged' &&
                  slotProps.item.check_out_at != null
                "
              >
                Completed
              </h5>
            </div>
          </div>
        </router-link>
      </template>
    </data-table-card>

    <b-modal
      :hide-footer="true"
      :title="$route.meta.title"
      size="lg"
      v-model="sidebarToggle"
      :no-close-on-route-change="true"
      @hidden="$router.push({ name: 'engagements' })"
      :lazy="true"
    >
      <router-view
        @engagementCreated="engagementCreated()"
        @engagementUpdated="engagementUpdated()"
        @checkedOut="checkedOutDone"
      ></router-view>
    </b-modal>
  </div>
</template>

<script>
import engagementRepo from "@/api/repos/engagementRepo";
import dataTableCard from "@/components/common/DataTableCard";

export default {
  components: {
    dataTableCard: dataTableCard,
  },

  data() {
    return {
      sidebarToggle: false,
      isLoad: false,
      sort: {
        column: "engagement_date",
        label: "Engagement Date Desc",
        order: "desc",
      },
      sortOptions: [
        { column: "engagement_date", label: "Engagement Asc", order: "asc" },
        { column: "engagement_date", label: "Engagement Desc", order: "desc" },
        { column: "created_at", label: "Date Created Asc", order: "asc" },
        { column: "created_at", label: "Date Created Desc", order: "desc" },
      ],
      filterOptions: [],
      filterStr: null,
      page: 1,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 12,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
      items: [],
    };
  },
  mounted() {
    this.getEngagements({
      sort: this.sort,
      filters: null,
      page: this.page,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 12,
      search: "",
    });
  },
  methods: {
    async getFilterData() {
      let { data } = await engagementRepo.createGetData();

      this.filterOptions.push({
        column: "group-heading",
        label: "status",
      });

      this.filterOptions.push({
        column: "status",
        value: "Created",
        label: "Created",
      });

      this.filterOptions.push({
        column: "status",
        value: "Engaged",
        label: "Engaged",
      });

      this.filterOptions.push({
        column: "status",
        value: "Cancelled",
        label: "Cancelled",
      });

      this.filterOptions.push({
        column: "group-heading",
        label: "mode",
      });

      data.modes.forEach((p) => {
        this.filterOptions.push({
          column: "mode",
          value: p,
          label: p,
        });
      });
    },

    async getEngagements(e) {
      if (e.filters != null) {
        this.filterStr = e.filters;
      } else {
        this.filterStr = null;
      }
      this.isLoad = true;
      try {
        let { data } = await engagementRepo.engagements(
          e.page,
          e.rowsPerPage,
          e.sort.column,
          e.sort.order,
          e.search,
          this.filterStr
        );

        this.items = data.engagements.data;
        this.totalRows = data.engagements.total;
        this.page = data.engagements.current_page;
        this.fromRow = data.engagements.from;
        this.toRow = data.engagements.to;
        this.lastPage = data.engagements.last_page;

        this.filterOptions = [];

        this.getFilterData();
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },

    engagementCreated() {
      this.$bvToast.toast("engagement Created", {
        title: "Success",
        autoHideDelay: 3000,
        variant: "success",
      });
      this.sort = {
        column: "created_at",
        label: "Date Created Desc",
        order: "desc",
      };
      this.page = 1;
      this.sidebarToggle = false;
      this.getEngagements({
        sort: this.sort,
        filters: null,
        page: this.page,
        rowsPerPage: localStorage.getItem("rowsPerPage")
          ? localStorage.getItem("rowsPerPage")
          : 12,
        search: "",
      });
    },

    engagementUpdated() {
      this.$bvToast.toast("engagement Updated", {
        title: "Success",
        autoHideDelay: 3000,
        variant: "success",
      });
      this.sidebarToggle = false;
      this.getEngagements({
        sort: this.sort,
        filters: null,
        page: this.page,
        rowsPerPage: localStorage.getItem("rowsPerPage")
          ? localStorage.getItem("rowsPerPage")
          : 12,
        search: "",
      });
    },

    checkedOutDone(e) {
      this.$bvToast.toast("Engagement Updated", {
        title: "Checked Out",
        autoHideDelay: 3000,
        variant: "success",
      });

      this.$router.push({
        name: "engagements-edit",
        params: { id: e },
      });
    },
  },

  watch: {
    $route: {
      immediate: true,
      handler: function (newVal) {
        this.sidebarToggle = newVal.meta && newVal.meta.sidebarToggle;
      },
    },
  },
};
</script>
